import { c as _c } from "react/compiler-runtime";
import { ListingCardShell, ListingCardImage, ListingCardContent } from "../parts";
import { RichTextDescription } from "@/components/common/rich-text/rich-text-description.component";
import type { RichTextDescription as RichTextDescriptionData } from "@/lib/sanity/sanity.types";
import type { VisualType } from "@/lib/types";
function DateBadge(t0) {
  const $ = _c(2);
  const {
    label
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <span className="absolute bottom-4 left-4 rounded-sm bg-bright-blue-500 px-2 py-2 text-center uppercase text-white typography-component-xs-medium">{label}</span>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export function EventCard(t0) {
  const $ = _c(20);
  const {
    visual,
    title,
    href,
    dateLabel,
    description,
    className,
    imageSizes,
    imageCropAspect,
    isLogo
  } = t0;
  let t1;
  if ($[0] !== dateLabel) {
    t1 = dateLabel ? <DateBadge label={dateLabel} /> : undefined;
    $[0] = dateLabel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== imageCropAspect || $[3] !== imageSizes || $[4] !== isLogo || $[5] !== t1 || $[6] !== visual) {
    t2 = <ListingCardImage visual={visual} overlay={t1} sizes={imageSizes} cropAspect={imageCropAspect} isLogo={isLogo} />;
    $[2] = imageCropAspect;
    $[3] = imageSizes;
    $[4] = isLogo;
    $[5] = t1;
    $[6] = visual;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== title) {
    t3 = <p className="w-full typography-component-sm-medium text-text-primary desktop:typography-component-md-medium">{title}</p>;
    $[8] = title;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== description) {
    t4 = description && description.length > 0 ? <RichTextDescription richText={description} compact={true} className="line-clamp-2 w-full" /> : null;
    $[10] = description;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = <ListingCardContent gapClass="gap-2">{t3}{t4}</ListingCardContent>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== className || $[16] !== href || $[17] !== t2 || $[18] !== t5) {
    t6 = <ListingCardShell href={href} gapClass="gap-3 desktop:gap-4" className={className}>{t2}{t5}</ListingCardShell>;
    $[15] = className;
    $[16] = href;
    $[17] = t2;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}